// AUTO-GENERATED by scripts/fetch-cms-content.mjs (DIT-264 / DIT-335 GG2).
// Gitignored — do NOT edit or commit. Empty `{}` means "nothing hidden".
/* eslint-disable */
export const CMS_HIDDEN_SECTIONS: Record<string, string[]> = {
  "int": [],
  "be": [],
  "lt": []
};
